import { forwardRef } from "react";
import { SVGFillRect, SVGIconRoot } from "./SVGComponents";
import { IconProps } from "./index";

export const Plus = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <SVGIconRoot viewBox="0 0 20 20" ref={ref} {...props}>
      <SVGFillRect y="8" width="20" height="4" />
      <SVGFillRect x="8" width="4" height="20" />
    </SVGIconRoot>
  );
});
